var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { themeLss } from "../../lss";
import styled, { css } from "../../styled";
import { selectButtonStyles } from './buttonStyles';
var horizontalScale = {
    sm: 'md',
    md: 'lg',
    lg: 'xl'
};
var verticalScale = {
    sm: 'sm',
    md: 'md',
    lg: 'lg'
};
var fontSizeScale = {
    sm: 'control',
    md: 'control',
    lg: 'content'
};
var buttonScale = function (_a) {
    var _b = _a.scale, scale = _b === void 0 ? 'md' : _b, theme = _a.theme;
    var horizontalPadding = theme.space[horizontalScale[scale]];
    var verticalPadding = theme.space[verticalScale[scale]];
    var typography = theme.typography[fontSizeScale[scale]];
    return __assign(__assign({ padding: verticalPadding + " " + horizontalPadding }, typography), { lineHeight: 1 });
};
export var buttonCss = css(buttonScale, function (_a) {
    var theme = _a.theme, disabled = _a.disabled, isBlock = _a.isBlock;
    return [
        "\n    cursor: " + (disabled ? 'not-allowed' : 'pointer') + ";\n    border: " + theme.borders.regular + ";\n    border-radius: " + theme.radii.sm + ";\n    opacity: " + (disabled ? theme.opacities.disabled : 1) + ";\n    background-position: center;\n    text-decoration: none;\n    " + (isBlock
            ? "\n        display: block;\n        width: 100%;\n        border-radius: 0;\n      "
            : "\n        display: inline-block;\n        ") + "\n    "
    ];
}, selectButtonStyles);
/**
 * Our basic button component
 */
export var Button = styled.button(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n  ", "\n"], ["\n  ", "\n  ", "\n"])), buttonCss, themeLss());
var templateObject_1;
//# sourceMappingURL=Button.js.map